<template>
  <transition
    v-if="$store.getters.getAcademyDaysLeft !== null"
    name="a-transtion-slide"
  >
    <div class="m-the-header-limit-date">
      <p>
        <span
          v-if="$store.getters.getAcademyDaysLeft > 0"
          class="font-weight-regular"
        >
          <i class="far fa-exclamation-triangle"></i>
          {{ $t('mTheHeaderLimitDate.upgrade.firstText') }}
          <u>{{ this.$store.getters.getAcademyDaysLeft }} {{ $t('mTheHeaderLimitDate.upgrade.secondText') }}</u>
          {{ $t('mTheHeaderLimitDate.upgrade.thirdText') }}
        </span>
        <span v-else>
          {{ $t('mTheHeaderLimitDate.upgrade.forcedUpgradeText') }}
        </span>
      </p>
      <router-link
        :to="`/${this.$t('rPaths.updateMyPlan')}`"
      >
        {{ $t('mTheHeaderLimitDate.upgrade.firstLinkText') }}
        <b>{{ $t('mTheHeaderLimitDate.upgrade.secondLinkText') }}</b>
        {{ $t('mTheHeaderLimitDate.upgrade.thirdLinkText') }}
      </router-link>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'MoleculeTheHeaderLimitDate',

  data () {
    return {
      fechaLicenciasLegacy: '2025-05-22 00:00:00',
      fechaEspanaAnterior: null,
      productsExcludes: ['bb83a7c0-4180-4b95-a5df-f10f9751bc25']
    }
  },

  mounted () {
    this.getDaysLeft()
    this.fechaEspanaAnterior = this.getFechaEspana()

    setInterval(() => {
      const fechaActual = this.getFechaEspana()
      if (fechaActual !== this.fechaEspanaAnterior) {
        this.fechaEspanaAnterior = fechaActual
        this.getDaysLeft(true)
      }
    }, 60 * 60 * 1000) // cada 1 hora
  },

  methods: {
    daysLeft (initDateStr) {
      const totalDias = 30
      const fechaInicio = new Date(initDateStr)
      // Nos aseguramos de que esté en medianoche
      fechaInicio.setHours(0, 0, 0, 0)

      // Obtener la fecha de hoy en Europa/Madrid sin la hora
      const now = new Date()
      const opciones = { timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit' }
      const fechaMadridStr = now.toLocaleDateString('en-CA', opciones) // 'YYYY-MM-DD'
      const hoyMadrid = new Date(fechaMadridStr + 'T00:00:00')

      // Calcular días transcurridos
      const diffMs = hoyMadrid - fechaInicio
      const diffDiasPasados = Math.floor(diffMs / (1000 * 60 * 60 * 24))

      const diasRestantes = totalDias - diffDiasPasados
      return diasRestantes > 0 ? diasRestantes : 0
    },

    getDaysLeft (newDaySpain = false) {
      if (this.$store.getters.getAcademyDaysLeft === null || newDaySpain) {
        this.$services.read('ventas', 'readVenta', {}, [this.$store.getters.getAcademyData.licencia.venta])
          .then(response => {
            if (this.productsExcludes.includes(response.data.venta.producto_venta)) return
            let stimatedDate = this.fechaLicenciasLegacy
            const dateFlag = response.data.venta.fecha_venta > stimatedDate ? response.data.venta.fecha_venta : stimatedDate
            this.$store.commit('setAcademyDaysLeft', this.daysLeft(dateFlag))
          })
          .catch(error => {
            console.log(error)
          })
      }
    },

    getFechaEspana () {
      const ahora = new Date()
      // Hora española es UTC+1 o +2 dependiendo del horario de verano
      const opciones = { timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit' }
      const fechaStr = ahora.toLocaleDateString('en-CA', opciones) // formato YYYY-MM-DD
      return fechaStr
    }
  }
}
</script>

<style scoped>
.m-the-header-limit-date {
  align-items: center;
  background-color: rgba(219, 104, 107, 1);
  color: var(--color-white);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: small;
  font-weight: 600;
  height: var(--the-header-upgrade-height-medium);
  line-height: var(--the-header-upgrade-height-medium);
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow-x: auto;
  padding: 0 var(--spacing-medium);
  width: 100%;

  & p {
    line-height: unset;
    margin: 0 var(--spacing-medium);
  }

  & a {
    background-color: var(--color-white);
    border-radius: var(--radius-medium);
    color: rgba(206, 55, 63, 1);
    height: fit-content;
    line-height: normal;
    margin: 0 var(--spacing-medium);
    padding: var(--spacing-xsmall) var(--spacing-small);
  }

  & .close-header-message {
    color: var(--color-white);
    font-size: var(--font-size-xsmall);
    vertical-align: middle;
    position: absolute;
    top: -10px;
    right: 10px;
  }

  @media (--viewport-landscape) {
    height: var(--the-header-upgrade-height-landscape);
    line-height: var(--the-header-upgrade-height-landscape);
  }
}
</style>
